export default __webpack_public_path__ + "static/media/img7.72ff1a14.jpg";